import React from 'react';
import { bool, func, string } from 'prop-types';
import styled from 'styled-components';

import Button from 'ravenjs/lib/Button';
import Typography from 'ravenjs/lib/Typography';

import USERS from 'constants/users';
import { MIGRATED_COLORS } from 'constants/quartz/migrated_colors';

const AccountSectionWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    flex: 1 1 auto;
    min-width: 0;
    width: 100%;

    @media (max-width: 675px) {
        align-items: flex-start;
        width: 100%;
    }
`;

const TextContainer = styled.div`
    display: block;
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
    white-space: normal;
    word-break: normal;
    overflow-wrap: break-word;
`;

const ButtonWrapper = styled.div`
    flex: 0 0 auto;
    align-self: center;
`;

const ButtonStyled = styled(Button)`
    font-size: 14px;
    font-family: 'Roboto';
`;

const AccountSection = ({ partnerName, isPrimaryAccount, onSwitchAccount }) => {
    const prefix = USERS.SWITCH_ACCOUNT_HEADER.VIEWING_PREFIX;
    const suffix = isPrimaryAccount ? USERS.SWITCH_ACCOUNT_HEADER.PRIMARY_SUFFIX : '';
    const title = `${prefix} ${partnerName}${suffix}`;

    return (
        <AccountSectionWrapper>
            <TextContainer title={title}>
                <Typography
                    as="span"
                    fontStyle="Bold"
                    fontWeight="700"
                    fontFamily="Roboto"
                    fontSize="16px"
                    lineHeight="150%"
                    gutterTop="0"
                    gutterBottom="0"
                    color={MIGRATED_COLORS.black00}
                >
                    {`${prefix}\u00A0`}
                </Typography>
                <Typography
                    as="span"
                    fontWeight="400"
                    fontSize="16px"
                    fontFamily="Roboto"
                    lineHeight="150%"
                    gutterTop="0"
                    gutterBottom="0"
                    color={MIGRATED_COLORS.black00}
                >
                    {partnerName}
                    {suffix}
                </Typography>
            </TextContainer>
            <ButtonWrapper>
                <ButtonStyled
                    color="primary"
                    onClick={onSwitchAccount}
                    data-pendo="account-switcher-button"
                >
                    {USERS.SWITCH_ACCOUNT_HEADER.BUTTON_LABEL}
                </ButtonStyled>
            </ButtonWrapper>
        </AccountSectionWrapper>
    );
};

AccountSection.propTypes = {
    partnerName: string.isRequired,
    isPrimaryAccount: bool,
    onSwitchAccount: func.isRequired,
};

AccountSection.defaultProps = {
    isPrimaryAccount: false,
};

export default AccountSection;
